import React, { useEffect, useState } from "react";
import { Avatar, Box, CircularProgress, Dialog, FormControl,  Grid, InputLabel, MenuItem, Select, Typography } 
from "@mui/material"; 
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import Viewmore from "../shared/viewmore";
import dayjs from "dayjs";
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import OndemandVideoOutlinedIcon from '@mui/icons-material/OndemandVideoOutlined';
import AudioFileOutlinedIcon from '@mui/icons-material/AudioFileOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CloseIcon from '@mui/icons-material/Close';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { colorcard, dashboardText, icon34, mainGrid, paddingbox, paddingboxeven, pcolor, pointer, rcolor } from "../../style2";
import { BorderTop } from "@mui/icons-material";


export default function HealthDiary(props) {
    // If startDate and endDate are supplied via props, the component operates in
    // date-range mode: it calls a different API endpoint, hides the month/year
    // selectors, and displays the date range in the heading instead.
    // When these props are absent, the default year/month selector behaviour applies.
    const { startDate, endDate } = props;
    const useDateRange = startDate && endDate;
    //const [selectedDate, setSelectedDate] = useState(new Date(Date.now()));
    const [selectedYear, setSelectYear] = useState(dayjs().year());
    const [selectedMonth, setSelectMonth] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(2);
    const rowsPerPageValue = 2;
    const [entries, setEntries] = useState([]);
    const [viewMore, setViewMore] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    //const [open, setOpen] = useState(false);
    //const [openViewMedication, setOpenViewMedication] = useState(false);
    const ls = new AccessLocalStorage();
    const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
    const [previewRecord, setPreviewRecord] = useState(null);
    const [filterDDOpen, setFilterDDOpen] = useState(false);
    const [filterList, setFilterList] = useState([]);
    const [tags, setTags] = useState({});
    const showSummary = ls.isPediatrician() || ls.isAdmin();
    const [addDialogOpen, setAddDialogOPen] = useState(false);

    const handlePreviewDialogOpen = (r) => {
        setPreviewDialogOpen(true);
        setPreviewRecord(r);
    };

    const handlePreviewDialogClose = () => {
        setPreviewDialogOpen(false);
        setPreviewRecord(null);
    };
    // const setMaxDate = (daysToAdd) => {
    //     const now = new Date();
    //     const nowPlusDays = now.setDate(now.getDate() + daysToAdd);
    //     return dayjs(nowPlusDays).format("YYYY-MM");
    // };
    const handleFilterChange = (checked, value) => {
        if (checked) {
            let temp = [...filterList];
            temp.push(value);
            setFilterList(temp);
        } else
            setFilterList(filterList.filter(t => t != value));
    };
    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            setError("Unauthorized. No token available.");
            setLoading(false);
            return;
        }

        const url = useDateRange
            ? `${getApiUrl()}/journal/getbyrange/${ls.getCurrentPatientId()}?startDate=${startDate}&endDate=${endDate}`
            : `${getApiUrl()}/journal/${ls.getCurrentPatientId()}/${selectedYear}/${selectedMonth}`;

        fetch(url,
            {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                let result = [];
                let tempTags = {};
                data.forEach((e) => {
                    if (!e.isDeleted) {
                        result.push(e);
                    }
                    for (let k in e.tags.filter(t => !t.isDeleted)) {
                        let t = e.tags[k];
                        if (t.journalTag.tagName in tempTags) {
                            tempTags[t.journalTag.tagName] = tempTags[t.journalTag.tagName] + 1;
                        } else {
                            tempTags[t.journalTag.tagName] = 1;
                        }
                    }
                });
                data.forEach((e) => {
                    if (e.isDeleted)
                        result.push(e);
                });

                setEntries(result);
                setTags(tempTags);
                //console.log(result);
                //console.log("Grouped By Tags Count:");
                //console.log(tempTags);
            })
            .catch((err) => {
                setError(err.message || "An error occurred.");
                setEntries([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [selectedYear, selectedMonth, props.newJournalCreatedTime, startDate, endDate]);

    const handleViewMore = () => {
        viewMore ? setViewMore(false) : setViewMore(true);
        viewMore ? setRowsPerPage(rowsPerPageValue) : setRowsPerPage(entries.length);
    };
    // const renderFilterOptions = () => {
    //     let items = [];
    //     for (const k of Object.keys(tags)) {
    //         items.push(<div><FormControlLabel classes={{ label: classes.filterdropdownitem }} control={<Checkbox defaultChecked={filterList.filter(t => t === k).length != 0}
    //             value={k} onChange={(event) => {handleFilterChange(event.target.checked, event.target.value);}} />} label={k} labelPlacement="start" /></div>);
    //     };
    //     return <>{items}</>;
    // }
    const getColor = (k) => {
        let bgcolor = "#38B6FF";
        let color = "#fff";
        switch (k) {
            case "Sleep":
                bgcolor = "#A46979";
                break;
            case "Inattention":
                bgcolor = "#ED8797";
                break;
            case "Hyperactivity":
                bgcolor = "#8C52FF";
                break;
            case "Behavior", "Appointment":
                bgcolor = "#E499DE";
                break;
            case "Social communication":
                bgcolor = "#7B9390";
                break;
            case "Posture":
                bgcolor = "#FFBD59";
                break;
            case "Sensory":
                bgcolor = "#95D9A5";
                color = "#115C71";
                break;
        }
        return { bgcolor, color };
    }

    const renderTags = () => {
        let items = [];
        let filterliststr = filterList.join(",");

        for (const k of Object.keys(tags)) {
            let opacity = filterliststr != "" && filterliststr.indexOf(k) == -1 ? 0.4 : 1;
            items.push(<Grid item xs={3} sx={{ padding: "10px", ...pointer }} onClick={() => {handleFilterChange(!(filterliststr.indexOf(k) > -1), k);}}>
                <Box sx={{ ...colorcard, opacity: opacity, backgroundColor: getColor(k).bgcolor, color: getColor(k).color }}>
                    <Avatar sx={{ backgroundColor: "#fff", color: "#115C71", float: "right",width: "30px", height: "30px", fontSize:"1rem" }}>
                        {tags[k]}
                    </Avatar>
                    {filterliststr.indexOf(k) == -1 ? null : <CheckCircleOutlineIcon sx={{ float: "left", color: "#fff", fontSize: "2rem" }} />}
                    <Box sx={{ position: "absolute", bottom: "10px" }}>{k}</Box>
                </Box>
            </Grid>);
        };
        return <>{items}</>;
    }

    const renderFilteredEntries = () => {
        if (filterList.length === 0)
            return entries;

        let items = [];
        let filterliststr = filterList.join(",");
        for (let i in entries) {
            if (entries[i].tags.length === 0)
                continue;
            for (let k in entries[i].tags.filter(t => !t.isDeleted)) {
                if (filterliststr.indexOf(entries[i].tags[k].journalTag.tagName) > -1) {
                    items.push(entries[i]);
                    break;
                }
            }
        }
        return items;
    }

    const renderYearOptions = () => {
        let items = [];
        let d = new Date(Date.now());
        for (let i = d.getFullYear(); i > d.getFullYear() - 25; i--) {
            items.push(<MenuItem value={i}>{i}</MenuItem>);
        }
        return items;
    }

    const renderMonthName = () => {
        switch (selectedMonth) {
            case 0:
                return "";
            case 1:
                return "Jan ";
            case 2:
                return "Feb ";
            case 3:
                return "Mar ";
            case 4:
                return "Apr ";
            case 5:
                return "May ";
            case 6:
                return "Jun ";
            case 7:
                return "Jul";
            case 8:
                return "Aug ";
            case 9:
                return "Sep ";
            case 10:
                return "Oct ";
            case 11:
                return "Nov ";
            case 12:
                return "Dec ";

        }
    }

    const renderIndicators = (entry, tag) => {
        let items = [];
        let filtered = entry.tagsIndicators.filter(t => t.journalTagID === tag.journalTag.journalTagID);
        for (let k in filtered) {
            let indicator = filtered[k];
            items.push(<Grid container direction="row" alignItems="flex-start" justifyContent="flex-start"
                sx={{ padding: "8px 20px", fontSize: "17px" }}><CheckBoxOutlinedIcon sx={{ marginRight: "10px" }} />
                {indicator.indicatorName}
            </Grid>);
        }
        return items;
    }

    return (<Box sx={(props.fullWidth ? null : paddingbox)} id={props.id}>
        <Grid container>
            <Grid item xs={12} container>
                <Grid item xs={useDateRange ? 12 : 8}>
                    <Box display="flex" alignItems="center" sx={dashboardText}>
                        <Box component="img" src={props.icon ? props.icon : `assets/diary.png`} sx={icon34}></Box> <Box mr={1} />
                        <Typography sx={dashboardText} variant="h6" component="div" marginLeft={1}>
                            {useDateRange
                                ? `Health Diary - ${dayjs(startDate).format("DD/MM/YY")} to ${dayjs(endDate).format("DD/MM/YY")}`
                                : `Health Diary - ${renderMonthName()}${selectedYear}`}
                        </Typography>
                        {loading ? <span style={{marginLeft:10}}><CircularProgress size={20} /></span> : null}
                    </Box>
                </Grid>
                {!useDateRange && (
                    <>
                        <Grid item xs={2} container direction="column" alignItems="flex-end" justifyContent="flex-end">
                            <FormControl fullWidth sx={{ marginBottom: 1, minWidth: 100, paddingRight: 1 }} size="small">
                                <InputLabel id="health-diary-month-select-label">Month</InputLabel>
                                <Select disabled={loading} labelId="health-diary-month-select-label"
                                    id="month-select" value={selectedMonth} label="Month" 
                                    onChange={(event) => { setSelectMonth(event.target.value); }}>
                                    <MenuItem value={0}>Month</MenuItem>
                                    <MenuItem value={1}>Jan</MenuItem>
                                    <MenuItem value={2}>Feb</MenuItem>
                                    <MenuItem value={3}>Mar</MenuItem>
                                    <MenuItem value={4}>Apr</MenuItem>
                                    <MenuItem value={5}>May</MenuItem>
                                    <MenuItem value={6}>Jun</MenuItem>
                                    <MenuItem value={7}>Jul</MenuItem>
                                    <MenuItem value={8}>Aug</MenuItem>
                                    <MenuItem value={9}>Sep</MenuItem>
                                    <MenuItem value={10}>Oct</MenuItem>
                                    <MenuItem value={11}>Nov</MenuItem>
                                    <MenuItem value={12}>Dec</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={2} container direction="column" alignItems="flex-end" justifyContent="flex-end">
                            <FormControl fullWidth sx={{ marginBottom: 1, minWidth: 100 }} size="small">
                                <InputLabel id="health-diary-year-select-label">Year</InputLabel>
                                <Select disabled={loading} labelId="health-diary-year-select-label"
                                    id="year-select" value={selectedYear} label="Year" onChange={(event) => { setSelectYear(event.target.value); }}>
                                    {renderYearOptions()}
                                </Select>
                            </FormControl>
                        </Grid>
                    </>
                )}
            </Grid>
            <Box m={1} />
            <Grid item xs={12}>
                <Box sx={{...mainGrid, padding: "20px" }}>
                    {showSummary ? <Grid container fullWidth>
                        <Grid item xs={11} >
                            {filterList.length > 0 ? <Box component="div" item xs={12} sx={{ margin: "5px 0px" }}>
                                {filterList.map((e) => { return (<Box component="span" sx={{ backgroundColor: "#EEEEEE", fontSize: "0.7rem", whiteSpace: "nowrap", padding: "4px 10px", marginBottom: "5px", marginRight: "20px", border: "1px solid #717273", borderRadius: "15px" }}>{e}</Box>); })}
                            </Box> : null}
                        </Grid>
                        {Object.keys(tags).length > 0 ? <>
                            {/* <Grid item xs={1} style={{ textAlign: "right" }}>
                                <div style={{ position: "relative" }}>
                                    <div direction="column" alignItems="middle" justifyContent="center" className={classes.pointer}>
                                        <IconButton onClick={() => { setFilterDDOpen(!filterDDOpen) }}><FilterListIcon /></IconButton>
                                    </div>
                                    {filterDDOpen ? <Box className={classes.paddingbox} style={{ position: "absolute", right: "0", borderRadius: "15px", border: "1px solid #fff", backgroundColor: lightcolor, padding: "10px", zIndex: 2 }}>
                                        {renderFilterOptions()}
                                    </Box> : null}
                                </div>
                            </Grid> */}
                            <Grid item container xs={12}>
                                {renderTags()}
                            </Grid>
                        </> : null}
                    </Grid> : null}
                    <div style={{ padding: "0.8rem" }}>
                        {renderFilteredEntries().length > 0 ? renderFilteredEntries().slice(0 * rowsPerPage, 0 * rowsPerPage + rowsPerPage)
                            .map((entry) => (
                                <div key={entry.id} style={{ backgroundColor: "#fff", borderRadius: "10px", marginBottom: "20px", padding: "15px 0px" }}>
                                    <div style={{ borderLeft: `4px solid ${pcolor}`, minHeight: "30px" }}>
                                        <Typography title="Journal Date" style={{ color: rcolor, fontWeight: "bold", fontSize: "1.2rem", textAlign: "center" }}>
                                            {dayjs(entry.journalDate).format("DD/MM/YYYY")}
                                        </Typography>
                                        <Grid container xs={12} >
                                            <Grid item xs={entry.files.length > 0 ? 6 : 12}>
                                                <div style={{ padding: "10px" }}>
                                                    {entry.tags.filter(t => !t.isDeleted).map((tag) => (
                                                        <>
                                                            <span style={{
                                                                color: getColor(tag.journalTag.tagName).color, background: getColor(tag.journalTag.tagName).bgcolor, fontWeight: "bold",
                                                                padding: "5px 15px", margin: "5px", borderRadius: "15px", fontSize: "15px", textTransform: "capitalize", display: "inline-block"
                                                            }}>{tag.journalTag.tagName}</span>
                                                            {renderIndicators(entry, tag)}<br/>
                                                        </>
                                                    ))}
                                                </div>
                                            </Grid>
                                            {entry.files.length > 0 ? <Grid item xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <div style={{ display: "inline-block", padding: "10px", color: "#545454", fontSize: "17px" }}>
                                                    {entry.files.map(file => (
                                                        <span onClick={() => handlePreviewDialogOpen(file)} style={{ display: "inline-block", color: "#115C71", cursor: "pointer", marginRight: "15px" }}>
                                                            {file.iconClass === "image" ? <InsertPhotoOutlinedIcon style={{ fontSize: "2.8rem" }} /> :
                                                                file.iconClass === "video" || file.s3FileName.indexOf(".mov") > -1 ? <OndemandVideoOutlinedIcon style={{ fontSize: "2.8rem" }} /> :
                                                                    file.iconClass === "audio" ? <AudioFileOutlinedIcon style={{ fontSize: "2.8rem" }} /> :
                                                                        file.iconClass === "document" ? <DescriptionOutlinedIcon style={{ fontSize: "2.8rem" }} /> : <AttachFileIcon style={{ fontSize: "2.8rem" }} />}
                                                        </span>
                                                    ))}
                                                </div>
                                            </Grid> : null}
                                        </Grid>
                                        {entry.note ? <Box sx={{ padding: "8px", borderBottom: "2px solid #F1EFDF", borderTop: "2px solid #F1EFDF" }}>
                                            <Typography sx={{ color: "#4FBFA8", fontSize: "17px" }}>
                                                {entry.note}
                                            </Typography>
                                        </Box> : null}
                                        
                                        <div style={{ padding: "1rem 1.5rem", textAlign: "right" }}>
                                            <span title="Create date of journal entry" style={{ color: "#545454", fontSize: "16px", paddingRight: "1.5rem" }}>{dayjs(entry.createdOn).format("DD/MM/YYYY")}</span>
                                            <span style={{ color: "#545454", fontSize: "16px" }}>{entry.createdByName}{entry.ownerId != entry.createdBy ? "" : ", Parent/Carer"}</span>
                                        </div>
                                    </div>
                                </div>
                            )) : loading ? null : <Box><Typography>No Health Diary Entries</Typography></Box>}
                    </div>
                    <div style={{ textAlign: "center", padding: 5, width: "100%", display: "block" }}>
                        {entries.length >= 3 ? (
                            <Viewmore handleViewMore={handleViewMore}></Viewmore>
                        ) : null}
                    </div>
                </Box>
                {previewDialogOpen ? <Dialog open={true} onClose={handlePreviewDialogClose} fullWidth maxWidth="md">
                    <Grid container style={{ backgroundColor: "#545454", color: "#fff", padding: "10px" }}>
                        <Grid item xs={11} >
                            <Typography>{previewRecord.displayName}</Typography>
                        </Grid>
                        <Grid item xs={1} style={{ textAlign: "right", cursor: "pointer" }}>
                            <CloseIcon onClick={handlePreviewDialogClose} />
                        </Grid>
                    </Grid>
                    {previewRecord.iconClass === "image" ?
                        <Grid style={{ backgroundColor: "#000", textAlign: "center", minHeight: "500px", maxHeight: "700px", overflowY: "auto" }}>
                            <img src={previewRecord.s3TempPath} style={{ maxWidth: "100%", height: "auto", minHeight: "500px" }} />
                        </Grid> : null}
                    {previewRecord.iconClass === "audio" ?
                        <Grid style={{ backgroundColor: "#000", textAlign: "center", padding: "10px" }}>
                            <audio controls src={previewRecord.s3TempPath} style={{ height: "50px", width: "100%" }}></audio>
                        </Grid> : null}
                    {previewRecord.iconClass === "video" || previewRecord.s3FileName.indexOf(".mov") > -1 ?
                        <Grid style={{ backgroundColor: "#000", textAlign: "center", padding: "10px" }}>
                            <video controls src={previewRecord.s3TempPath} style={{ width: "100%", height: "600px" }}></video>
                        </Grid> : null}
                    {previewRecord.iconClass === "document" ?
                        <Grid style={{ backgroundColor: "transparent", textAlign: "center", height: "600px", paddingBottom: "5px" }}>
                            <iframe src={previewRecord.s3TempPath} style={{ width: "100%", height: "100%" }}></iframe>
                        </Grid> : null}
                </Dialog> : null}
            </Grid>
        </Grid>
    </Box>);
}